export default __webpack_public_path__ + "static/media/icon-social-secure.e9607591.svg";